export const getIsFeedbackDialogOpen = state => state.footer.isFeedbackDialogOpen;

export const getIsChatButtonShown = state => state.footer.isChatButtonShown;

export const getFooter = state => state.footer.footer;
